import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { useCheckPermission } from 'src/utils/checkPermission';

export interface TopBlockPropsType {
  newCarrier: boolean;
  disableEdit: boolean;
  handleSave: () => void;
  handleDelete?: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
  const canDelete = useCheckPermission('CARRIER.DELETE');

  return (
    <>
      <BodyTopBlock
        actions={[
          {
            label: translate(props.newCarrier ? 'carrierDetail.create' : 'carrierDetail.save'),
            onClick: () => {
              props.handleSave();
            },
            hidden: props.disableEdit,
          },
          {
            label: translate('carrierDetail.delete'),
            onClick: () => props.handleDelete && props.handleDelete(),
            hidden: props.newCarrier || !canDelete,
            variant: 'outlined',
          },
        ]}
      />
    </>
  );
};

export default TopBlock;

